<div ng-if="!editable">{{selectedOption.text}}</div>
<div ng-if="editable" class="select" ng-click="toggleOptions()">
    <div class="selected" ng-class="{'has-value':selectedOption.value!=''}" ng-bind-html="selectedOption.text"></div>
    <i ng-if="canBeFiltered" ng-class="{'is-filtered': isFiltered }" ng-click="toggleFilter($event)" class="menu-filter fa fa-filter"></i>
    <i class="menu-angle fa fa-angle-down"></i>
</div>
<div ng-if="showOptions" class="select-menu-container">
    <ul class="option-list">
        <li ng-repeat="option in filterOptions()" ng-click="select(option)" class="option">
            <span ng-class="{'bold':option.value==selectedOption.value }" ng-bind-html="option.text"></span>
            <div class="labels" ng-if="filter.labels">
                <span ng-repeat="label in option.labels" ng-click="selectLabel(label, $event)" class="label" ng-style="labelStyle(label)" title="{{label.Description|translate}}">{{label.Name|translate}}</span>
            </div>
        </li>
    </ul>
</div>
<div ng-if="showFilter && editable" class="select-menu-container">
    <div ng-if="filter.labels" class="label-filter">
        {{'dropdown.filter.onLabel'|translate}} <span class="clear-filter" ng-click="clearLabelFilter()">{{'dropdown.filter.clearLabels'|translate}}</span>
    </div>
    <ul class="option-list" ng-if="filter.labels">
        <li ng-repeat="label in filter.labels" ng-click="selectLabel(label, $event)">
            <span class="check" ng-style="isLabelSelected(label)">✔</span> <span class="label" ng-style="labelStyle(label)">{{label.Name|translate}}</span> <span>{{label.Description|translate}}</span>
        </li>
    </ul>
</div>